import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { Row, Col } from 'react-bootstrap';
import cn from 'classnames';
import Slider from 'react-slick';

import { IoIosArrowDroprightCircle as NextArrow, IoIosArrowDropleftCircle as PrevArrow } from 'react-icons/io';

import Logo from '../event_components/logo';
import Title from '../event_components/title';
import Location from '../event_components/location';
import GeoMap from '../event_components/geo_map';
import Time from '../event_components/time';
import Details from '../event_components/details';
import AttendButton from '../event_components/attend_button';
import Ticket from '../event_components/ticket';
import styles from './feature.scss';
import GoogleLocation from '../event_components/google_location';
import { LocaleWrapper } from '../../locale-wrapper';
import PaginationContainer from './pagination_container';

const propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
};

function FeatureEvent({ event, settings, onResizeComponent, tickets }) {
  const hasLogo = settings.get('showEventLogo');
  return (
    <div className={cn('event', styles.details, styles.flexVertical, styles.feature)}>
      {hasLogo && (
        <Row className={styles.flexChild}>
          <Col xs={12}>
            <Logo event={event} settings={settings} showBackground className={styles.logo} isSlider />
          </Col>
        </Row>
      )}
      <span className={styles.content}>
        <Row className={styles.row}>
          <Col xs={12}>
            <Title event={event} className="small-top-padding" settings={settings} />
          </Col>
        </Row>
        <Row className={styles.row}>
          <Col xs={12} className={styles.details}>
            <Time settings={settings} event={event} />
          </Col>
        </Row>
        <hr />
        <Row className={cn(styles.flexChild, styles.row)}>
          <Col xs={12}>
            <Details event={event} settings={settings} onResizeComponent={onResizeComponent} />
          </Col>
        </Row>
        {event.get('venue') && (settings.get('showVenue') || settings.get('showFullAddress')) && (
          <Row className={styles.row}>
            <Col xs={9} className={styles.map}>
              <GeoMap event={event} settings={settings} showGoogleMap />
            </Col>
            <Col xs={3}>
              {event.get('type') === 'google' ? (
                <GoogleLocation event={event} />
              ) : (
                <Location event={event} settings={settings} showFullAddress={settings.get('showFullAddress')} className={styles.location} withIcon />
              )}
            </Col>
          </Row>
        )}
        <Row className={styles.row}>
          <Col xs={6} className="pull-left ticket">
            <Ticket event={event} settings={settings} tickets={tickets} />
          </Col>
          {!settings.get('removeAttendButton') && (
            <Col xs={6} className={cn('pull-right', styles.buttonContainer)}>
              <AttendButton className={styles.button} event={event} settings={settings} />
            </Col>
          )}
        </Row>
      </span>
    </div>
  );
}

FeatureEvent.propTypes = propTypes;

function FeatureEventContainer({ events, settings, onResizeComponent }) {
  const config = {
    className: styles.featureSlider,
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    pauseOnHover: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dotsClass: 'dot',
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const renderEvent = (event) => (
    <LocaleWrapper>
      <FeatureEvent key={event.get('id')} event={event} settings={settings} />
    </LocaleWrapper>
  );
  return (
    <Slider {...config}>
      <PaginationContainer events={events} settings={settings} onResizeComponent={onResizeComponent} renderEvent={renderEvent} />
    </Slider>
  );
}

FeatureEventContainer.propTypes = {
  events: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
};

export default FeatureEventContainer;
